export default "__VITE_ASSET__0900298f__"